import script from "./TrainerDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./TrainerDetailModal.vue?vue&type=style&index=0&id=2e052ef9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e052ef9"]])

export default __exports__